export const DASHBOARD_USERS = ["riccardo"];

export function canAccessOrdersDashboard(user) {
    return user?.is_active !== false && DASHBOARD_USERS.includes(user?.username);
}
